const md = `# The 3 Procurement Workflows

Three production workflows ship with the Demo Agent.  They all log in
to \`ibuy.cloud\` as the configured demo user, build a requisition
header, then add a line item using a different entry method.

## 1. Create Requisition — Free-form Line Item

**Slug:** \`create-requisition-freeform\`

What it demos: a buyer who knows exactly what they want and types it
in manually.  Best for showcasing the speed of a simple ad-hoc
purchase request.

End state: a real \`DRAFT\` requisition with one populated line item:
Item Description, Suggested Supplier (picked from the auto-complete),
Quantity, Price, Item Due Date.  Confirmed via the "Item added" toast
and the *Line Items* tab badge advancing from 0 → 1.

Typical runtime (presentation pace): **~2:55**.

## 2. Create Requisition — Catalog Item

**Slug:** \`create-requisition-catalog\`

What it demos: pre-approved supplier catalog.  Search for an item
(default keyword *laptop*), pick the first hit, the line item is added
in one click.

End state: same as above, but the line item carries the supplier and
SKU from the catalog (e.g. *Dell Latitude 5540 Laptop 15"*).

Typical runtime (presentation pace): **~2:30**.

## 3. Create Requisition — PunchOut (Office Depot)

**Slug:** \`create-requisition-punchout-office-depot\`

What it demos: cXML supplier round-trip.  Opens the PunchOut supplier
picker (UPS / G4S / Herman Miller / ISS / KPMG / Workday) and selects
the configured supplier (default Workday Inc.).

**Known limitation on the demo tenant:** the supplier picker click
focus-highlights the supplier card but does *not* trigger the cXML
redirect, because the demo tenant has no live cXML credentials wired
for these suppliers.  In production this would land on the supplier's
hosted catalog.  The slug retains "office-depot" for backward compat —
Office Depot is **not** one of the six configured suppliers on this
tenant.

Typical runtime (presentation pace): **~2:00**.

## Choosing between them

| Audience | Best workflow |
|----------|----------------|
| Net-new buyer asking "how fast is this?" | Free-form |
| Buyer who already knows your supplier story | Catalog |
| Procurement leader who cares about supplier integration | PunchOut |
| Executive 30-second skim | Catalog (auto-pipeline on, fast pacing) |
`;

export default md;
